import React, { useState, useRef, useEffect } from "react";
import CountUp from "react-countup";


const Section1 = ({ url }) => {

  const [counterOn, setCounterOn] = useState(false);
  const statsRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setCounterOn(true);
        }
      },
      { threshold: 0.4 }
    );
  
    if (statsRef.current) observer.observe(statsRef.current);
  
    return () => observer.disconnect();
  }, []);

  const stats = [
  { end: 10, suffix: "+", label: "Developers\nAvailable" },
  { end: 50, suffix: "+", label: "US/UK/CA Client\nServed" },
  { end: 50, suffix: "+", label: "Projects\nDelivered" },
  { end: 100, suffix: "%", label: "Timezone-Matched\nDelivery" },
];

const logos = [
  "Movig.png",
  "Mairotec.png",
  "Embark.png",
  "Evgo.png",
  "Brain-Box.png",
  "pepsico.png",
  "SBM.png",
  "Fidelity.png",
  "InteliHire.png",
  "Zones.png",
  "zorbis.png"
];

  return (
    <section className="home-section-1 text-center"
    
    style={{
        // backgroundImage: `url("https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe")`,
        backgroundImage: `url("${url}images/offshoreDevelopment/background.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed"
    }}

    >
      <div className="container overflow-hidden">

        <h1 className="hero-title" data-aos="fade-up">
          <span className="orange-text">Offshore Software</span> Development
          <br />
          Services That Work the Way <br/> Your Business Expects
        </h1>

        <p className="hero-subtitle mt-3" data-aos="fade-up" data-aos-delay="100">
         <strong> ExD Digital </strong> provides US, UK, and Canadian businesses with dedicated offshore development teams based in Pakistan. Senior-caliber engineers. Your timezone. Your standards. Delivered at a fraction of the cost of local hiring, without the quality compromise your previous offshore experience may have taught you to expect.
        </p>

        <div className="cta-row" data-aos="fade-up" data-aos-delay="200">
         <span className="cta-note order-2 order-md-1">
            30 minutes. We will match you with the right developers for your stack and scope. No commitment required.
         </span>
         <button className="btn-cta order-1 order-md-2">
            Book Your Free Discovery Call &nbsp;→
          </button>
        </div>

        <div className="hero-image-frame" data-aos="fade-up" data-aos-delay="350">
          <img src={`${url}images/offshoreDevelopment/banner.png`} alt="AI Development" />
        </div>

        {/* ── STATS BAR ── */}
        <div className="stats-grid" data-aos="fade-up" data-aos-delay="450" ref={statsRef}>
          {/* <div className="stat-item">
            <span className="stat-number">10+</span>
            <span className="stat-label">Developers<br />Available</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">US/UK/CA Clients<br />Served</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">Projects<br />Delivered</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Timezone-Matched<br />Delivery</span>
          </div> */}
           {stats.map((stat, idx) => (
              <div className="stat-item" key={idx}>
                
                <span className="stat-number">
                  {counterOn ? (
                    <CountUp
                      start={0}
                      end={stat.end}
                      duration={2}
                      separator=","
                    />
                  ) : (
                    0
                  )}
                  {stat.suffix}
                </span>

                <span className="stat-label">
                  {stat.label.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i === 0 && <br />}
                    </React.Fragment>
                  ))}
                </span>

              </div>
            ))}
        </div>

        {/* ── TRUSTED BY ── */}
        {/* <div className="trusted-section" data-aos="fade-up" data-aos-delay="550">
          <p className="trusted-label">TRUSTED BY BUSINESSES ACROSS INDUSTRIES</p>
          <div className="logo-row">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div className="logo-circle" key={i}>
                <img src={`${url}images/clients/logo-${i}.png`} alt={`Client ${i}`} />
              </div>
            ))}
          </div>
        </div> */}

      </div>
     {/* ── TRUSTED BY — full width, outside container ── */}
    <div className="trusted-section" data-aos="fade-up" data-aos-delay="550">
    <p className="trusted-label">TRUSTED BY BUSINESSES ACROSS INDUSTRIES</p>
    <div className="logo-marquee-wrapper">
        <div
            className="logo-marquee-track"
            onMouseEnter={e => e.currentTarget.style.animationPlayState = 'paused'}
            onMouseLeave={e => e.currentTarget.style.animationPlayState = 'running'}
        >
        {/* {[...Array(4)].flatMap((_, pass) =>
            [1, 2, 3, 4, 5, 6].map((i) => (
            <div className="logo-circle" key={`${pass}-${i}`}>
                <img src={`${url}images/clients/logo-${i}.png`} alt={`Client ${i}`} />
            </div>
            ))
        )} */}

            {[...Array(4)].flatMap((_, pass) =>
            logos.map((logo, index) => (
              <div className="logo-circle" key={`${pass}-${index}`}>
                <img
                  src={`${url}images/clogos/${logo}`}
                  alt={logo.replace(".png", "")}
                />
              </div>
            ))
          )}
        </div>
    </div>
    </div>
    </section>
  );
};

export default Section1;